document.addEventListener('DOMContentLoaded', function() { 
  document.querySelectorAll('.header__nav__item').forEach(menuItem => {
    menuItem.addEventListener('mouseenter', () => {
      const dropdown = menuItem.querySelector('.header__dropdown');
      if (!dropdown) return;

      dropdown.style.marginLeft = '';
      dropdown.style.marginRight = '';

      const rect = dropdown.getBoundingClientRect();

     // if (rect.left < 0) {
     //   dropdown.style.marginLeft = '20rem';
     // } else if (rect.right > window.innerWidth) {
     //   dropdown.style.marginRight = '20rem';
     // }
    });
  });
});
